/* FB | iOS zoom engeli v2 — iPhone'da HER TUR yakinlastirmayi kapatir, calisan yapiyi bozmaz.
   Kapatilan 3 zoom turu:
   1) INPUT ODAK ZOOM'U: iOS, font-size < 16px olan bir input'a dokunulunca otomatik yakinlasir
      (sepetteki adet kutusu 13px -> "sepet acikken arada sirada yakinlasiyor" sorununun kok sebebi).
      Cozum: viewport meta'ya maximum-scale=1 (iOS bunu odak-zoom'u icin dinler).
   2) CIFT DOKUNMA ZOOM'U: touch-action:manipulation (tek dokunus tiklama/scroll AYNEN calisir).
   3) IKI PARMAK PINCH: gesturestart/change/end + cok-parmakli touchmove engeli.
   Tek parmak kaydirma, tiklama, drawer scroll'u, urun galerisinin kendi zoom diyalogu ETKILENMEZ. */
(function(){
  'use strict';

  /* 1) Viewport kilidi: input odak zoom'unu kapatir. Morph/re-render sonrasi da korunur. */
  var VIEWPORT='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
  function lockViewport(){
    try{
      var m=document.querySelector('meta[name="viewport"]');
      if(!m){ m=document.createElement('meta'); m.setAttribute('name','viewport'); (document.head||document.documentElement).appendChild(m); }
      if(m.getAttribute('content')!==VIEWPORT) m.setAttribute('content', VIEWPORT);
    }catch(e){}
  }
  lockViewport();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', lockViewport);
  window.addEventListener('load', lockViewport);
  window.addEventListener('pageshow', lockViewport);

  /* 2) Cift dokunma zoom'u: CSS touch-action:manipulation (pan + tiklama serbest, double-tap zoom kapali).
     NOT: inline style DEGIL stylesheet -> drawer'in scroll kilidi (inline touch-action) gerektiginde ustune biner, catisma yok. */
  function injectStyle(){
    try{
      if(document.getElementById('fb-no-zoom-style')) return;
      var st=document.createElement('style');
      st.id='fb-no-zoom-style';
      st.textContent='html,body{touch-action:manipulation;}';
      (document.head||document.documentElement).appendChild(st);
    }catch(e){}
  }
  injectStyle();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', injectStyle);

  /* 3) Pinch (iki parmak) engeli: iOS gesture event'leri + cok-parmakli touchmove.
     Tek parmakli event'lere dokunulmaz -> normal scroll/tiklama aynen calisir. */
  function block(e){ if (e && e.preventDefault) e.preventDefault(); }
  document.addEventListener('gesturestart', block, { passive: false });
  document.addEventListener('gesturechange', block, { passive: false });
  document.addEventListener('gestureend', block, { passive: false });
  document.addEventListener('touchmove', function(e){
    try{ if(e.touches && e.touches.length>1) e.preventDefault(); }catch(err){}
  }, { passive: false });
})();
